import { useMemo } from 'react'

import { useDefaultLayoutProps } from '../../layouts/DefaultLayout/useProps'

import { PageTemplateProps } from './index'

export const usePageTemplateProps = (): PageTemplateProps => {
  const layoutProps = useDefaultLayoutProps()

  return useMemo(
    () => ({
      layout: layoutProps,
    }),
    [layoutProps]
  )
}
